import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Swiper from 'react-id-swiper';
import SwiperCore, { Pagination } from 'swiper';
import { useStaticState } from '@phishtool/ui';
import { StyledWrapper, StyledImage } from './styled';
import Modal from './modal';
SwiperCore.use([Pagination]);
const Slider = ({ images }) => {
    const [overlayIndex, setOverlayIndex] = useState(null);
    const [staticData] = useStaticState();
    const srcs = images.map((image) => {
        var _a;
        const name = `assets/${image}-small.png`;
        return (_a = staticData === null || staticData === void 0 ? void 0 : staticData.manifest) === null || _a === void 0 ? void 0 : _a[name];
    });
    const modalSrcs = images
        .map((image) => {
        var _a;
        const name = `assets/${image}.png`;
        return (_a = staticData === null || staticData === void 0 ? void 0 : staticData.manifest) === null || _a === void 0 ? void 0 : _a[name];
    })
        .filter((src) => !!src);
    useEffect(() => {
        modalSrcs.forEach((src) => {
            const img = new Image();
            img.src = src;
        });
    }, []);
    const props = {
        loop: true,
        threshold: 5,
        spaceBetween: 10,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        on: {
            click: (swiper, event) => {
                if (event.target.tagName === 'IMG') {
                    setOverlayIndex(swiper.realIndex);
                }
            },
        },
    };
    return (_jsxs(_Fragment, { children: [_jsx(StyledWrapper, { children: _jsx(Swiper, Object.assign({}, props, { children: srcs.map((src) => (_jsx(StyledImage, { src: src, alt: "" }, src))) })) }), overlayIndex !== null && (_jsx(Modal, { srcs: modalSrcs, overlayIndex: overlayIndex, setOverlayIndex: setOverlayIndex }))] }));
};
export default Slider;
